// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setChartId = createAction('[Fund Chart] Set Chart Id', props());
